import React, { Component } from 'react';
import { connect } from 'react-redux';
import moize from 'moize';
import { Grid, Row, Col } from '@bit/knotchinc.web-react-components.grid';
import { KeywordsListTile } from 'components/Tiles';
import { SectionTitle } from 'components/Global/Title/Title.jsx';
import Mixpanel from 'helpers/Mixpanel.js';
import { ADD_ENTITY_INSIGHTS } from '../actions';
import InsightsBrandLogos from './InsightsBrandLogos.jsx';

class KeywordsInsightsTab extends Component {
  constructor() {
    super();
    this.memoFetchMap = moize((entities, fetch) => this.generateFetchMap(entities, fetch));
  }

  componentDidMount() {
    Mixpanel.track(`view Insights: keywords tab`);
  }

  generateFetchMap(entities, fetch) {
    return entities.reduce((acc, key) => {
      acc[key] = (clear) => fetch(clear, key);
      return acc;
    }, {});
  }

  render() {
    const { keywords, entities, metadata, fetchData } = this.props;
    const entitiesList = entities.map(entity => ({ entityId: entity, keywordData: keywords[entity] }));
    const fetchMap = this.memoFetchMap(entities, fetchData);
    const multiEntity = entitiesList.length > 1;

    return (
      <Grid height="auto">
        <InsightsBrandLogos metadata={metadata} />
        <Row weight={multiEntity ? 9 : 10}>
          {entitiesList.map((keywordList) => (
            <Col centered key={`col-keywords-${keywordList.entityId}`}>
              <SectionTitle>Keywords</SectionTitle>
              <KeywordsListTile fetchData={fetchMap[keywordList.entityId]} store={keywordList.keywordData} multiEntity={multiEntity} />
            </Col>
            ))}
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = ({ Insights: { keywords, metadata } }) => ({
  keywords,
  metadata,
  entities: Object.keys(keywords),
});

const mapDispatchToProps = (dispatch, { entityType }) => ({
  initializeEntity: entityId => dispatch({ type: ADD_ENTITY_INSIGHTS, entityId, entityType }),
});

export default connect(mapStateToProps, mapDispatchToProps)(KeywordsInsightsTab);
